import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const Gallery = () => {
  const { category } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery data for each category
  const galleries = {
    'weddings': {
      title: 'Weddings',
      description: 'Capturing your most precious moments on your special day',
      images: [
        { id: 1, src: '/Weddings/wedding cover.JPG', alt: 'Wedding photo 1' },
        { id: 2, src: '/Weddings/JCCM0244.JPG', alt: 'Wedding photo 2' },
        { id: 3, src: '/Weddings/JCCM0281.JPG', alt: 'Wedding photo 3' },
        { id: 4, src: '/Weddings/JCCM0310.JPG', alt: 'Wedding photo 4' },
        { id: 5, src: '/Weddings/JCCM0462.JPG', alt: 'Wedding photo 5' },
        { id: 6, src: '/Weddings/JCCM0469.JPG', alt: 'Wedding photo 6' },
        { id: 7, src: '/Weddings/JCCM9696.JPG', alt: 'Wedding photo 7' },
        { id: 8, src: '/Weddings/JCCM9775.JPG', alt: 'Wedding photo 8' },
        { id: 9, src: '/Weddings/JCCM9811.JPG', alt: 'Wedding photo 9' },
      ]
    },
    'portraits': {
      title: 'Portraits',
      description: 'Stunning portrait photography that captures your essence',
      images: [
        { id: 1, src: '/Portrait/IMG_0269.JPG', alt: 'Portrait photo 1' },
        { id: 2, src: '/Portrait/IMG_4114.jpg', alt: 'Portrait photo 2' },
        { id: 3, src: '/Portrait/IMG_4159.jpg', alt: 'Portrait photo 3' },
        { id: 4, src: '/Portrait/IMG_4164 B&W.jpg', alt: 'Portrait photo 4' },
        { id: 5, src: '/Portrait/IMG_4182.jpg', alt: 'Portrait photo 5' },
        { id: 6, src: '/Portrait/IMG_4217.jpg', alt: 'Portrait photo 6' },
        { id: 7, src: '/Portrait/IMG_7055.jpg', alt: 'Portrait photo 7' },
        { id: 8, src: '/Portrait/IMG_7057.jpg', alt: 'Portrait photo 8' },
        { id: 9, src: '/Portrait/IMG_7060.jpg', alt: 'Portrait photo 9' },
        { id: 10, src: '/Portrait/JCCM0944.JPG', alt: 'Portrait photo 10' },
        { id: 11, src: '/Portrait/JCCM4639.jpg', alt: 'Portrait photo 11' },
        { id: 12, src: '/Portrait/JCCM4647.jpg', alt: 'Portrait photo 12' },
        { id: 13, src: '/Portrait/JCCM4686.jpg', alt: 'Portrait photo 13' },
        { id: 14, src: '/Portrait/JCCM5022.jpg', alt: 'Portrait photo 14' },
      ]
    },
    'events': {
      title: 'Events',
      description: 'Professional event coverage for all occasions',
      images: []
    },
    'live-performance': {
      title: 'Live Performance',
      description: 'Capturing the energy and excitement of live shows',
      images: [
        { id: 1, src: '/Live performance/IMG_0054.jpg', alt: 'Performance photo 1' },
        { id: 2, src: '/Live performance/IMG_0100.jpg', alt: 'Performance photo 2' },
        { id: 3, src: '/Live performance/IMG_0276.jpg', alt: 'Performance photo 3' },
        { id: 4, src: '/Live performance/IMG_0319.jpg', alt: 'Performance photo 4' },
        { id: 5, src: '/Live performance/IMG_0362.jpg', alt: 'Performance photo 5' },
        { id: 6, src: '/Live performance/IMG_0377.jpg', alt: 'Performance photo 6' },
        { id: 7, src: '/Live performance/IMG_1095.jpg', alt: 'Performance photo 7' },
        { id: 8, src: '/Live performance/IMG_1377.jpg', alt: 'Performance photo 8' },
        { id: 9, src: '/Live performance/IMG_1468.jpg', alt: 'Performance photo 9' },
        { id: 10, src: '/Live performance/IMG_1997.jpg', alt: 'Performance photo 10' },
        { id: 11, src: '/Live performance/IMG_2082.jpg', alt: 'Performance photo 11' },
        { id: 12, src: '/Live performance/IMG_2137.jpg', alt: 'Performance photo 12' },
        { id: 13, src: '/Live performance/IMG_2244.jpg', alt: 'Performance photo 13' },
        { id: 14, src: '/Live performance/IMG_2315.jpg', alt: 'Performance photo 14' },
        { id: 15, src: '/Live performance/IMG_2406.jpg', alt: 'Performance photo 15' },
        { id: 16, src: '/Live performance/IMG_2424.jpg', alt: 'Performance photo 16' },
        { id: 17, src: '/Live performance/IMG_2583.jpg', alt: 'Performance photo 17' },
        { id: 18, src: '/Live performance/IMG_2772.jpg', alt: 'Performance photo 18' },
        { id: 19, src: '/Live performance/IMG_6321.jpg', alt: 'Performance photo 19' },
        { id: 20, src: '/Live performance/IMG_6452.jpg', alt: 'Performance photo 20' },
        { id: 21, src: '/Live performance/IMG_6514.jpg', alt: 'Performance photo 21' },
        { id: 22, src: '/Live performance/IMG_6520.jpg', alt: 'Performance photo 22' },
        { id: 23, src: '/Live performance/IMG_7772.jpg', alt: 'Performance photo 23' },
        { id: 24, src: '/Live performance/IMG_7799.jpg', alt: 'Performance photo 24' },
        { id: 25, src: '/Live performance/IMG_7940.JPG', alt: 'Performance photo 25' },
        { id: 26, src: '/Live performance/IMG_8106.jpg', alt: 'Performance photo 26' },
        { id: 27, src: '/Live performance/IMG_8744.JPG', alt: 'Performance photo 27' },
        { id: 28, src: '/Live performance/IMG_8888.jpg', alt: 'Performance photo 28' },
        { id: 29, src: '/Live performance/IMG_8921.jpg', alt: 'Performance photo 29' },
        { id: 30, src: '/Live performance/IMG_8940.jpg', alt: 'Performance photo 30' },
        { id: 31, src: '/Live performance/IMG_9388.JPG', alt: 'Performance photo 31' },
        { id: 32, src: '/Live performance/IMG_9500.JPG', alt: 'Performance photo 32' },
        { id: 33, src: '/Live performance/IMG_9519.jpg', alt: 'Performance photo 33' },
        { id: 34, src: '/Live performance/IMG_9593.JPG', alt: 'Performance photo 34' },
        { id: 35, src: '/Live performance/IMG_9806.JPG', alt: 'Performance photo 35' },
        { id: 36, src: '/Live performance/JCCM5134.jpg', alt: 'Performance photo 36' },
        { id: 37, src: '/Live performance/JCCM9226.jpg', alt: 'Performance photo 37' },
        { id: 38, src: '/Live performance/JCCM9268.jpg', alt: 'Performance photo 38' },
      ]
    },
    // Archived galleries (kept for future use)
    'proposal-day': {
      title: 'Proposal Day',
      description: 'Capturing the magic of your special moment',
      images: []
    },
    'event': {
      title: 'Event',
      description: 'Professional event coverage',
      images: []
    },
    'portrait': {
      title: 'Portrait',
      description: 'Stunning portrait photography',
      images: []
    },
    'graduation': {
      title: 'Graduation',
      description: 'Celebrating your achievements',
      images: [
        { id: 1, src: '/Graduation/IMG_5315.jpg', alt: 'Graduation photo 1' },
        { id: 2, src: '/Graduation/IMG_5318.jpg', alt: 'Graduation photo 2' },
        { id: 3, src: '/Graduation/IMG_5356.jpg', alt: 'Graduation photo 3' },
        { id: 4, src: '/Graduation/IMG_5367.jpg', alt: 'Graduation photo 4' },
        { id: 5, src: '/Graduation/IMG_5407.jpg', alt: 'Graduation photo 5' },
        { id: 6, src: '/Graduation/IMG_5459.jpg', alt: 'Graduation photo 6' },
        { id: 7, src: '/Graduation/IMG_5481.jpg', alt: 'Graduation photo 7' },
        { id: 8, src: '/Graduation/IMG_5488.jpg', alt: 'Graduation photo 8' },
        { id: 9, src: '/Graduation/IMG_5630.jpg', alt: 'Graduation photo 9' },
        { id: 10, src: '/Graduation/IMG_5689.jpg', alt: 'Graduation photo 10' },
        { id: 11, src: '/Graduation/IMG_5727.jpg', alt: 'Graduation photo 11' },
      ]
    },
    'engagement': {
      title: 'Engagement',
      description: 'Celebrating your love and commitment',
      images: [
        { id: 1, src: '/Engagement/IMG_1671.jpg', alt: 'Engagement photo 1' },
        { id: 2, src: '/Engagement/IMG_1677.jpg', alt: 'Engagement photo 2' },
        { id: 3, src: '/Engagement/IMG_1697.jpg', alt: 'Engagement photo 3' },
        { id: 4, src: '/Engagement/IMG_1703.jpg', alt: 'Engagement photo 4' },
        { id: 5, src: '/Engagement/IMG_1718.jpg', alt: 'Engagement photo 5' },
        { id: 6, src: '/Engagement/IMG_1736.jpg', alt: 'Engagement photo 6' },
        { id: 7, src: '/Engagement/IMG_1812.jpg', alt: 'Engagement photo 7' },
        { id: 8, src: '/Engagement/IMG_1844.jpg', alt: 'Engagement photo 8' },
      ]
    },
    'shows': {
      title: 'Shows',
      description: 'Dynamic show photography',
      images: []
    },
    'candid-moments': {
      title: 'Candid Moments',
      description: 'Natural, unposed photography',
      images: []
    },
    'the-crew': {
      title: 'The Crew',
      description: 'Group and team photography',
      images: []
    }
  };

  const currentGallery = galleries[category];

  if (!currentGallery) {
    return (
      <div className="pt-20 md:pt-24 min-h-screen bg-light flex items-center justify-center">
        <div className="text-center">
          <h1 className="font-serif text-4xl font-bold text-forest mb-4">Gallery Not Found</h1>
          <Link to="/" className="text-forest hover:text-secondary">Return to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20 md:pt-24 min-h-screen bg-light">
      {/* Hero Section */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-forest via-secondary to-forest text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 bg-accent rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-white rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <Link to="/" className="inline-block text-white/80 hover:text-white mb-4 transition-colors">
            ← Back to Portfolio
          </Link>
          <h1 className="font-serif text-4xl md:text-6xl font-bold mb-4">
            {currentGallery.title}
          </h1>
          <p className="text-xl text-gray-200">
            {currentGallery.description}
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {currentGallery.images.map((image) => (
              <div
                key={image.id}
                className="group relative aspect-square overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  width="400"
                  height="400"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  style={{ contentVisibility: 'auto' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest/80 via-forest/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            ))}
          </div>

          {/* Empty State - removed since all galleries now have multiple images */}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-accent transition-colors z-10"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* CTA Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-6">
            Like What You See?
          </h2>
          <p className="text-xl text-secondary mb-8">
            Let's create something beautiful together
          </p>
          <div className="flex flex-col gap-6">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-block bg-forest text-white font-semibold px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                Book a Session
              </Link>
              <Link
                to="/"
                className="inline-block bg-card text-forest font-semibold px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                Back to Portfolio
              </Link>
            </div>
            <div className="flex justify-center">
              <Link
                to="/galleries"
                className="inline-block bg-gradient-to-r from-forest to-secondary text-white font-bold px-12 py-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 border-2 border-accent"
              >
                <span className="flex items-center gap-2">
                  View Full Portfolio
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
